webpackJsonp([69393897021146],{

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shibui = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STYLES = {
	  textAlign: 'center',
	  marginTop: '45px',
	  color: _shibui.colors.midnight.color
	};
	
	var COMMUNITY_LINK = 'https://join.slack.com/t/haiku-community/shared_invite/enQtMzc4OTg5NjcyNzIwLWJkYzJmY2FhZGI0NTE0N2JlNWFkOTM2NWYwZDRhNjNlNjgyNzA5ZDdlMmMxOWRjMDUzNzlhMWYzMzcxZTYzZjk';
	
	var SlackCommunity = function (_Component) {
	  _inherits(SlackCommunity, _Component);
	
	  function SlackCommunity() {
	    _classCallCheck(this, SlackCommunity);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SlackCommunity.prototype.componentDidMount = function componentDidMount() {
	    window.location.href = COMMUNITY_LINK;
	  };
	
	  SlackCommunity.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { style: STYLES },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Redirecting to Haiku Community Slack...'
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: COMMUNITY_LINK },
	        _react2.default.createElement(
	          'small',
	          null,
	          'Click here if that doesn\u2019t happen'
	        )
	      )
	    );
	  };
	
	  return SlackCommunity;
	}(_react.Component);
	
	exports.default = SlackCommunity;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-slack-community-js-a3f49e341ab723eee303.js